// What the CVC migration page remembers about the operator's choice: the page
// link (?cvc=<id>&target=<hostId>) and the last CVC chosen in this browser.

export const LAST_CVC_KEY = 'cvcMigration.lastCvcId';

// A link or storage value counts only when it is a positive whole number.
const positiveId = (value) => {
  if (typeof value !== 'string' || !/^[1-9]\d*$/.test(value)) return null;
  const id = Number(value);
  return Number.isSafeInteger(id) ? id : null;
};

// The page query for the chosen CVC and chosen target; other keys are kept.
// Clearing the CVC drops both, and a target without a CVC means nothing.
export function selectionQuery (query, { cvcId, targetHostId }) {
  const next = Object.assign({}, query);
  delete next.cvc;
  delete next.target;
  if (cvcId) {
    next.cvc = String(cvcId);
    if (targetHostId) next.target = String(targetHostId);
  }
  return next;
}

// The CVC (and target) to open once the lists have loaded. A link wins over the
// stored CVC, even a link with a bad value: that shows the picker. An id that
// is not in the lists is ignored, never reported. The target comes from the
// link only, and only when it is a known host.
export function initialSelection ({ query, stored, cvcs, hosts }) {
  const asked = query || {};
  const fromLink = asked.cvc !== undefined;
  const cvcId = fromLink ? positiveId(asked.cvc) : stored;
  if (!cvcId || !(cvcs || []).some(c => c.id === cvcId)) return null;
  const target = fromLink ? positiveId(asked.target) : null;
  const known = !!target && (hosts || []).some(h => h.id === target);
  return { cvcId, targetHostId: known ? target : 0 };
}

// Browsers can refuse the storage object itself (blocked cookies) as well as
// each call, so every access is inside a try.
const browserStorage = () => {
  try {
    return window.localStorage;
  } catch (e) {
    return null;
  }
};

export function readLastCvc (storage = browserStorage()) {
  try {
    return positiveId(storage.getItem(LAST_CVC_KEY));
  } catch (e) {
    return null;
  }
}

export function writeLastCvc (cvcId, storage = browserStorage()) {
  try {
    if (cvcId) storage.setItem(LAST_CVC_KEY, String(cvcId));
    else storage.removeItem(LAST_CVC_KEY);
  } catch (e) {
    // The page works without the memory.
  }
}
